import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guestCart: [], // 👈 SIEMPRE array
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart(state, action) {
      // 🛡 blindaje extra
      if (!Array.isArray(state.guestCart)) {
        state.guestCart = [];
      }

      const product = action.payload;
      const existing = state.guestCart.find(
        (i) => i.id === product.id
      );

      if (existing) {
        existing.quantity += 1;
      } else {
        state.guestCart.push({
          ...product,
          quantity: 1,
        });
      }
    },

    increaseQuantity(state, action) {
      const item = state.guestCart.find(
        (i) => i.id === action.payload.id
      );
      if (item) item.quantity += 1;
    },

    decreaseQuantity(state, action) {
      const item = state.guestCart.find(
        (i) => i.id === action.payload.id
      );
      if (!item) return;

      if (item.quantity <= 1) {
        state.guestCart = state.guestCart.filter(
          (i) => i.id !== item.id
        );
      } else {
        item.quantity -= 1;
      }
    },

    removeFromCart(state, action) {
      state.guestCart = state.guestCart.filter(
        (i) => i.id !== action.payload.id
      );
    },

    clearCart(state) {
      state.guestCart = [];
    },
  },
});

export const {
  addToCart,
  increaseQuantity,
  decreaseQuantity,
  removeFromCart,
  clearCart,
} = cartSlice.actions;

export default cartSlice.reducer;
